import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

import * as FormGroups from './formGroups'

const EditarZonaModal = ({ handleClose, show, reloadTable, modalData, tipoTabla }) => {
  const __zariContext = React.useContext(ZariContext)

  const submitHandler = async data => {
    await TablasComunesService.actualizarxId(modalData._id, data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha actualizado.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const formInitialValues = React.useMemo(
    () => ({
      porcentaje: modalData.porcentaje || '',
      nombre: modalData.nombre || '',
      estado: modalData.estado || '',
      codigo: modalData.codigo || '',
      tipo: tipoTabla
    }),
    [modalData, tipoTabla]
  )

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>EDITAR</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              {tipoTabla === TiposTablaComunConstant.DETRACCION && (
                <FormGroups.PorcentajeFormGroup
                  iError={errors.porcentaje}
                  iTouched={touched.porcentaje}
                  fIsSubmitting={isSubmitting}
                />
              )}
              <FormGroups.EstadoFormGroup
                iError={errors.estado}
                iTouched={touched.estado}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Actualizar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarZonaModal
